import React, { useState } from "react";
import Logo from "../../../assets/images/logo.jpg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { routes } from "../../../routes";

const Header = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(false);

  const toogleActive = () => {
    setActive((active) => {
      return !active;
    });
  };
  return (
    <div className="header_container">
      <div className="box_container">
        <div className="header_wraper">
          <Link to={routes.home} className="header_logo_container" onClick={() => setActive(false)}>
            <img src={Logo} alt="logo_ecole229" />
          </Link>
          <div className="header_links_container">
            <div className="header_links">
              <NavLink
                className={(nav) => (nav.isActive ? "nav-active" : "")}
                to={routes.formation}
              >
                Parcours
              </NavLink>
            </div>
            {/* <div className="header_links">
              <NavLink
                className={(nav) => (nav.isActive ? "nav-active" : "")}
                to={routes.process}
              >
                Admisions
              </NavLink>
            </div> */}
            <div className="header_links">
              <NavLink
                className={(nav) => (nav.isActive ? "nav-active" : "")}
                to={routes.community}
              >
                Communauté
              </NavLink>
            </div>
          </div>
          <div className="header_links_container">
            <button className="cta_btn">
              <Link to={routes.application.application} className="">
                Postuler maintenant
              </Link>
            </button>
          </div>
          <div className="burger_menu" onClick={toogleActive}>
            <span className="pi pi-bars"></span>
          </div>
        </div>
      </div>

      <div className="header_mobile_links_container"
      style={
        active
          ? {
              display: "block",
              height: "auto",
            }
          : {}
      }>
        <div className="header_mobile_links" onClick={() => setActive(false)}>
          <NavLink
            className={(nav) => (nav.isActive ? "nav-active" : "")}
            to={routes.formation}
          >
            Parcours
          </NavLink>
        </div>
        {/* <div className="header_mobile_links" onClick={() => setActive(false)}>
          <NavLink
            className={(nav) => (nav.isActive ? "nav-active" : "")}
            to={routes.process}
          >
            Admisions
          </NavLink>
        </div> */}
        <div className="header_mobile_links" onClick={() => setActive(false)}>
          <NavLink
            className={(nav) => (nav.isActive ? "nav-active" : "")}
            to={routes.community}
          >
            Communauté
          </NavLink>
        </div>
        <div className="header_mobile_links">
            <button className="cta_btn">
              <Link to={routes.application.application} className="">
                Postuler maintenant
              </Link>
            </button>
          </div>
      </div>
    </div>
  );
};

export default Header;
